import React from "react" ;
import { Switch, Route, Link } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import { Globals } from "root/DataFunctions/BaseDataFns";

import Gallery from "../Pages/Gallery";
import LifeStory from "../Pages/LifeStory";

const LifeStoryAndGallery = (props) => {
    const pathArray = props.location.pathname.split("/");
    const currentPageName = pathArray[pathArray.length - 1];

    const storyIconUrl = Globals.BaseURL + "/images/icons/child/script.png";
    const galleryIconUrl = Globals.BaseURL + "/images/icons/child/gallery.png";
    
    return (
        <div className="child-body-content">
            <div className="child-body-content-inner">
                <div className="post-nav">
                    <div className="navigation">
                        <ul>
                            <li 
                                className={currentPageName === "lifestoryandgallery" ? "list active" : "list"}
                            >
                                <Link to="/child/lifestoryandgallery">                      
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-right">
                                                Life Story
                                            </Tooltip>
                                        }
                                        >
                                        <span className="icon">
                                            <img className="img" src={storyIconUrl} alt="Life story icon" />
                                        </span>
                                    </OverlayTrigger>
                                </Link>
                            </li>

                            <li 
                                className={currentPageName === "gallery" ? "list active" : "list"}
                            >
                                <Link to="/child/lifestoryandgallery/gallery">
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-right">
                                                Gallery
                                            </Tooltip>
                                        }
                                        >
                                        <span className="icon">
                                            <img className="img" src={galleryIconUrl} alt="Gallery icon" />
                                        </span>
                                    </OverlayTrigger>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <Switch>
                    <Route exact path="/child/lifestoryandgallery/gallery" component={Gallery} />
                    <Route exact path="/child/lifestoryandgallery" component={LifeStory} />
                </Switch>

            </div>
        </div>
    );
}

export default LifeStoryAndGallery;
